// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Subsonic__GetAlbum from "../api/subsonic/getAlbum.jsx";

function make(albumId) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetAlbum.make(albumId), {
      credentials: state.auth.credentials
    }), (function (param) {
      const song = param.song;
      const state = store.getState();
      const baseById = MergeIntoMap.mergeIntoMap(state.albums.baseById, [{
          artist: param.artist,
          artistId: param.artistId,
          coverArt: param.coverArt,
          duration: param.duration,
          genre: param.genre,
          genres: param.genres,
          id: param.id,
          musicBrainzId: param.musicBrainzId,
          name: param.name,
          songCount: param.songCount,
          starred: param.starred,
          userRating: param.userRating,
          year: param.year
        }], (function (param) {
        return albumId;
      }));
      const state$1 = store.getState();
      const detailsById = MergeIntoMap.mergeIntoMap(state$1.albums.detailsById, [{
          discTitles: param.discTitles,
          isCompilation: param.isCompilation,
          originalReleaseDate: param.originalReleaseDate,
          releaseDate: param.releaseDate
        }], (function (param) {
        return albumId;
      }));
      const state$2 = store.getState();
      const songIdsById = MergeIntoMap.mergeIntoMap(state$2.albums.songIdsById, [song.map(function (x) {
          return x.id;
        })], (function (param) {
        return albumId;
      }));
      const state$3 = store.getState();
      const songsById = MergeIntoMap.mergeIntoMap(state$3.songs.byId, song, (function (x) {
        return x.id;
      }));
      const state$4 = store.getState();
      if (baseById !== state$4.albums.baseById || detailsById !== state$4.albums.detailsById || songIdsById !== state$4.albums.songIdsById || songsById !== state$4.songs.byId) {
        store.setState(function (prevState) {
          const init = prevState.albums;
          return {
            albums: {
              baseById: baseById,
              detailsById: detailsById,
              infoById: init.infoById,
              songIdsById: songIdsById
            },
            artists: prevState.artists,
            auth: prevState.auth,
            player: prevState.player,
            songs: {
              byId: songsById
            }
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
